// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { LiftType } from "./lift-type";
import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * Organization-scoped custom key override for a specific bank.
 */
export class CustomKey implements flatbuffers.IUnpackableObject<CustomKeyT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): CustomKey {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsCustomKey(bb: flatbuffers.ByteBuffer, obj?: CustomKey): CustomKey {
    return (obj || new CustomKey()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsCustomKey(bb: flatbuffers.ByteBuffer, obj?: CustomKey): CustomKey {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new CustomKey()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  id(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  organizationId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  bankId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  fbsDeviceType(): LiftType {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : LiftType.ELEVATOR;
  }

  encodedType(): number {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  messageContent(): number {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  messageValue(): number {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  position(): number {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  /**
   * `FlatBuffer`-encoded key value (Config.KeyValue union).
   */
  valueBinary(index: number): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.readUint8(this.bb!.__vector(this.bb_pos + offset) + index) : 0;
  }

  valueBinaryLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  valueBinaryArray(): Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset
      ? new Uint8Array(
          this.bb!.bytes().buffer,
          this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
          this.bb!.__vector_len(this.bb_pos + offset),
        )
      : null;
  }

  createdAt(): string | null;
  createdAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  createdAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  updatedAt(): string | null;
  updatedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  updatedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  deletedAt(): string | null;
  deletedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  deletedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  static startCustomKey(builder: flatbuffers.Builder) {
    builder.startObject(12);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, idOffset, 0);
  }

  static addOrganizationId(builder: flatbuffers.Builder, organizationIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, organizationIdOffset, 0);
  }

  static addBankId(builder: flatbuffers.Builder, bankIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, bankIdOffset, 0);
  }

  static addFbsDeviceType(builder: flatbuffers.Builder, fbsDeviceType: LiftType) {
    builder.addFieldInt8(3, fbsDeviceType, LiftType.ELEVATOR);
  }

  static addEncodedType(builder: flatbuffers.Builder, encodedType: number) {
    builder.addFieldInt16(4, encodedType, 0);
  }

  static addMessageContent(builder: flatbuffers.Builder, messageContent: number) {
    builder.addFieldInt16(5, messageContent, 0);
  }

  static addMessageValue(builder: flatbuffers.Builder, messageValue: number) {
    builder.addFieldInt32(6, messageValue, 0);
  }

  static addPosition(builder: flatbuffers.Builder, position: number) {
    builder.addFieldInt16(7, position, 0);
  }

  static addValueBinary(builder: flatbuffers.Builder, valueBinaryOffset: flatbuffers.Offset) {
    builder.addFieldOffset(8, valueBinaryOffset, 0);
  }

  static createValueBinaryVector(
    builder: flatbuffers.Builder,
    data: number[] | Uint8Array,
  ): flatbuffers.Offset {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(data[i]!);
    }
    return builder.endVector();
  }

  static startValueBinaryVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1);
  }

  static addCreatedAt(builder: flatbuffers.Builder, createdAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(9, createdAtOffset, 0);
  }

  static addUpdatedAt(builder: flatbuffers.Builder, updatedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(10, updatedAtOffset, 0);
  }

  static addDeletedAt(builder: flatbuffers.Builder, deletedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(11, deletedAtOffset, 0);
  }

  static endCustomKey(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // id
    builder.requiredField(offset, 6); // organization_id
    builder.requiredField(offset, 8); // bank_id
    return offset;
  }

  unpack(): CustomKeyT {
    return new CustomKeyT(
      this.id() !== null ? this.id()!.unpack() : null,
      this.organizationId() !== null ? this.organizationId()!.unpack() : null,
      this.bankId() !== null ? this.bankId()!.unpack() : null,
      this.fbsDeviceType(),
      this.encodedType(),
      this.messageContent(),
      this.messageValue(),
      this.position(),
      this.bb!.createScalarList<number>(this.valueBinary.bind(this), this.valueBinaryLength()),
      this.createdAt(),
      this.updatedAt(),
      this.deletedAt(),
    );
  }

  unpackTo(_o: CustomKeyT): void {
    _o.id = this.id() !== null ? this.id()!.unpack() : null;
    _o.organizationId = this.organizationId() !== null ? this.organizationId()!.unpack() : null;
    _o.bankId = this.bankId() !== null ? this.bankId()!.unpack() : null;
    _o.fbsDeviceType = this.fbsDeviceType();
    _o.encodedType = this.encodedType();
    _o.messageContent = this.messageContent();
    _o.messageValue = this.messageValue();
    _o.position = this.position();
    _o.valueBinary = this.bb!.createScalarList<number>(
      this.valueBinary.bind(this),
      this.valueBinaryLength(),
    );
    _o.createdAt = this.createdAt();
    _o.updatedAt = this.updatedAt();
    _o.deletedAt = this.deletedAt();
  }

  unpackFields(...fields: string[]): CustomKeyT {
    const t = new CustomKeyT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id() !== null ? this.id()!.unpack() : null;
    }
    if (fieldSet.has("organization_id")) {
      t.organizationId = this.organizationId() !== null ? this.organizationId()!.unpack() : null;
    }
    if (fieldSet.has("bank_id")) {
      t.bankId = this.bankId() !== null ? this.bankId()!.unpack() : null;
    }
    if (fieldSet.has("fbs_device_type")) {
      t.fbsDeviceType = this.fbsDeviceType();
    }
    if (fieldSet.has("encoded_type")) {
      t.encodedType = this.encodedType();
    }
    if (fieldSet.has("message_content")) {
      t.messageContent = this.messageContent();
    }
    if (fieldSet.has("message_value")) {
      t.messageValue = this.messageValue();
    }
    if (fieldSet.has("position")) {
      t.position = this.position();
    }
    if (fieldSet.has("value_binary")) {
      t.valueBinary = this.bb!.createScalarList<number>(
        this.valueBinary.bind(this),
        this.valueBinaryLength(),
      );
    }
    if (fieldSet.has("created_at")) {
      t.createdAt = this.createdAt();
    }
    if (fieldSet.has("updated_at")) {
      t.updatedAt = this.updatedAt();
    }
    if (fieldSet.has("deleted_at")) {
      t.deletedAt = this.deletedAt();
    }
    return t;
  }
}

export class CustomKeyT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: UuidT | null = null,
    public organizationId: UuidT | null = null,
    public bankId: UuidT | null = null,
    public fbsDeviceType: LiftType = LiftType.ELEVATOR,
    public encodedType: number = 0,
    public messageContent: number = 0,
    public messageValue: number = 0,
    public position: number = 0,
    public valueBinary: number[] = [],
    public createdAt: string | Uint8Array | null = null,
    public updatedAt: string | Uint8Array | null = null,
    public deletedAt: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.id === null || this.id === undefined) {
      throw new Error('Required field "id" is not set');
    }
    if (this.organizationId === null || this.organizationId === undefined) {
      throw new Error('Required field "organization_id" is not set');
    }
    if (this.bankId === null || this.bankId === undefined) {
      throw new Error('Required field "bank_id" is not set');
    }
    const id = this.id !== null ? this.id!.pack(builder) : 0;
    const organizationId = this.organizationId !== null ? this.organizationId!.pack(builder) : 0;
    const bankId = this.bankId !== null ? this.bankId!.pack(builder) : 0;
    const valueBinary = CustomKey.createValueBinaryVector(builder, this.valueBinary);
    const createdAt = this.createdAt !== null ? builder.createString(this.createdAt!) : 0;
    const updatedAt = this.updatedAt !== null ? builder.createString(this.updatedAt!) : 0;
    const deletedAt = this.deletedAt !== null ? builder.createString(this.deletedAt!) : 0;

    CustomKey.startCustomKey(builder);
    CustomKey.addId(builder, id);
    CustomKey.addOrganizationId(builder, organizationId);
    CustomKey.addBankId(builder, bankId);
    CustomKey.addFbsDeviceType(builder, this.fbsDeviceType);
    CustomKey.addEncodedType(builder, this.encodedType);
    CustomKey.addMessageContent(builder, this.messageContent);
    CustomKey.addMessageValue(builder, this.messageValue);
    CustomKey.addPosition(builder, this.position);
    CustomKey.addValueBinary(builder, valueBinary);
    CustomKey.addCreatedAt(builder, createdAt);
    CustomKey.addUpdatedAt(builder, updatedAt);
    CustomKey.addDeletedAt(builder, deletedAt);

    return CustomKey.endCustomKey(builder);
  }

  clone(): CustomKeyT {
    const obj = new CustomKeyT();
    obj.id = this.id !== null ? this.id!.clone() : null;
    obj.organizationId = this.organizationId !== null ? this.organizationId!.clone() : null;
    obj.bankId = this.bankId !== null ? this.bankId!.clone() : null;
    obj.fbsDeviceType = this.fbsDeviceType;
    obj.encodedType = this.encodedType;
    obj.messageContent = this.messageContent;
    obj.messageValue = this.messageValue;
    obj.position = this.position;
    obj.valueBinary = [...this.valueBinary];
    obj.createdAt = this.createdAt;
    obj.updatedAt = this.updatedAt;
    obj.deletedAt = this.deletedAt;
    return obj;
  }

  equals(other: CustomKeyT): boolean {
    if (this.id !== null && other.id !== null) {
      if (!this.id!.equals(other.id!)) return false;
    } else if (this.id !== other.id) return false;
    if (this.organizationId !== null && other.organizationId !== null) {
      if (!this.organizationId!.equals(other.organizationId!)) return false;
    } else if (this.organizationId !== other.organizationId) return false;
    if (this.bankId !== null && other.bankId !== null) {
      if (!this.bankId!.equals(other.bankId!)) return false;
    } else if (this.bankId !== other.bankId) return false;
    if (this.fbsDeviceType !== other.fbsDeviceType) return false;
    if (this.encodedType !== other.encodedType) return false;
    if (this.messageContent !== other.messageContent) return false;
    if (this.messageValue !== other.messageValue) return false;
    if (this.position !== other.position) return false;
    if (this.valueBinary.length !== other.valueBinary.length) return false;
    for (let i = 0; i < this.valueBinary.length; i++) {
      if (this.valueBinary[i] !== other.valueBinary[i]) return false;
    }
    if (this.createdAt !== other.createdAt) return false;
    if (this.updatedAt !== other.updatedAt) return false;
    if (this.deletedAt !== other.deletedAt) return false;
    return true;
  }
}

export function verifyCustomKey(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "id");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "organization_id");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 8);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 8, "bank_id");
    verifier.checkScalarField(tablePos, 10, 1);
    verifier.checkScalarField(tablePos, 12, 2);
    verifier.checkScalarField(tablePos, 14, 2);
    verifier.checkScalarField(tablePos, 16, 4);
    verifier.checkScalarField(tablePos, 18, 2);
    {
      const pos = verifier.checkOffsetField(tablePos, 20);
      if (pos !== 0) {
        verifier.checkVector(pos, 1);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 22);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 24);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 26);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
